import { camelCaseToLabel } from '@/sections/insights/queryBuilder/entities/utils/camelCaseToLabel';

/**
 * Formats field names for display in the QueryBuilder UI
 * - Applies special case overrides for domain-specific terms
 * - Falls back to camelCaseToLabel for automatic conversion
 * - Handles edge cases (empty, already formatted)
 *
 * @param fieldName - Raw field name (e.g., 'attackSurface', 'status')
 * @returns Formatted display name (e.g., 'Attack Surface', 'Status')
 *
 * @example
 * formatFieldName('attackSurface') // 'Attack Surface' (override)
 * formatFieldName('status') // 'Status' (camelCase conversion)
 * formatFieldName('ipAddress') // 'IP Address' (camelCase conversion)
 */
export function formatFieldName(fieldName: string): string {
  // Special case overrides (takes precedence over automatic conversion)
  const FIELD_OVERRIDES: Record<string, string> = {
    attackSurface: 'Attack Surface',
    // Add more special cases here as needed
  };

  // Check overrides first
  if (FIELD_OVERRIDES[fieldName]) {
    return FIELD_OVERRIDES[fieldName];
  }

  // Fall back to existing camelCaseToLabel utility
  return camelCaseToLabel(fieldName);
}
